<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(classes.id)" v-if="classes.id && $can('class-delete')" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  name="classes.name"
                  v-model="classes.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('classes.name')"
                  :error-messages="errors.collect('classes.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-autocomplete
                  name="classes.coursetypegroup_id"
                  ref="coursetypegroup_id"
                  v-model="classes.coursetypegroup_id"
                  @change="courseGroupChange(classes.coursetypegroup_id)"
                  :items="coursetypegroups"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypegroups.title')"
                  :error-messages="errors.collect('classes.coursetypegroup_id')"
                  autocomplete="new-password"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-autocomplete
                  name="classes.coursetype_id"
                  v-model="classes.coursetype_id"
                  :items="coursetypes"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypes.title')"
                  :error-messages="errors.collect('classes.coursetype_id')"
                  autocomplete="new-password"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  name="classes.duration"
                  v-model="classes.duration"
                  class="required-field"
                  v-validate="'required|max:10|numeric'"
                  :label="$t('classes.duration')"
                  :error-messages="errors.collect('classes.duration')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-select
                  name="classes.duration_type"
                  v-model="classes.duration_type"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_classes_duration_type()"
                  :label="$t('classes.duration_type')"
                  :error-messages="errors.collect('classes.duration_type')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-select
                  name="classes.status"
                  class="required-field"
                  v-validate="'required'"
                  v-model="classes.status"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_classes_status()"
                  :label="$t('classes.status')"
                  :error-messages="errors.collect('classes.status')"
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "ClassForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      predata: {},
      classes: {},
      coursetypes: [],
      coursetypegroups: [],
      dictionary: {
        attributes: {
          "classes.duration": this.$t("classes.duration"),
          "classes.status": this.$t("classes.status"),
          "classes.duration_type": this.$t("classes.duration_type"),
          "classes.name": this.$t("classes.name"),
          "classes.coursetype_id": this.$t("classes.coursetype_id"),
          "classes.coursetypegroup_id": this.$t("classes.coursetypegroup_id")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.classes, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    let lists = [
      {
        key: "coursetypegroups",
        module: "coursetypegroups",
        query: "show_all=true&sort_by=category&sort_order=asc"
      }
    ]

    axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.coursetypegroups = res.data.coursetypegroups

      if (!this.id) {
        this.page_title = this.$t("classes.new_classes")
        this.classes = {}
        this.classes = {
          duration_type: this.$getDefaultDropdown(this.$dd_classes_duration_type()),
          status: this.$getDefaultDropdown(this.$dd_classes_status())
        }
        // JSON stringify and parse to remove variable reactiveness
        this.predata = JSON.parse(JSON.stringify(this.classes))
      } else {
        this.title = this.$t("classes.update_title")

        axios
          .get(this.API_URL + "class/" + this.id)
          .then((res) => {
            this.classes = res.data.data
            // JSON stringify and parse to remove variable reactiveness
            this.predata = JSON.parse(JSON.stringify(this.classes))

            this.courseGroupChange(this.classes.coursetypegroup_id)

            this.page_title = this.$t("classes.edit_classes", {
              duration: this.classes.duration,
              duration_type: this.classes.duration_type,
              status: this.classes.status,
              name: this.classes.name
            })
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    courseGroupChange(groupId) {
      axios
        .get(this.API_URL + "coursetypes?show_all=true&sort_by=category&sort_order=asc&query_coursetypegroup_id=" + groupId)
        .then((res) => {
          this.coursetypes = res.data.data
          this.$refs.coursetypegroup_id.focus()
        })
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.classes.id) {
              // Create
              axios
                .post(this.API_URL + "class", {
                  name: this.classes.name,
                  coursetypegroup_id: this.classes.coursetypegroup_id,
                  coursetype_id: this.classes.coursetype_id,
                  duration: this.classes.duration,
                  duration_type: this.classes.duration_type,
                  status: this.classes.status
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.classes = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.classes))

                      vm.page_title = vm.$t("classes.edit_classes", {
                        duration: vm.classes.duration,
                        duration_type: vm.classes.duration_type,
                        status: vm.classes.status,
                        name: vm.classes.name
                      })

                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/classes/edit/${vm.classes.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "class", {
                  id: this.classes.id,
                  name: this.classes.name,
                  coursetypegroup_id: this.classes.coursetypegroup_id,
                  coursetype_id: this.classes.coursetype_id,
                  duration: this.classes.duration,
                  duration_type: this.classes.duration_type,
                  status: this.classes.status
                })
                .then((res) => {
                  vm.classes = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.classes))

                  vm.page_title = vm.$t("classes.edit_classes", {
                    duration: vm.classes.duration,
                    duration_type: vm.classes.duration_type,
                    status: vm.classes.status,
                    name: vm.classes.name
                  })

                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "class/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/classes")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
